import { computed } from "vue";
import { useRoute } from "vue-router";

const noNav = new URLSearchParams(document.location.search).has("noNav");

export function useLayout() {
  const route = useRoute();
  const showFrame = computed(() => !!route.meta.roles && !route.meta.hideMenu && !noNav);
  return { noNav, showFrame };
}
